import { LimitedShrinkArbitrary } from './_internals/LimitedShrinkArbitrary.js';
export function limitShrink(arbitrary, maxShrinks) {
    return new LimitedShrinkArbitrary(arbitrary, maxShrinks);
}
